import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import Nav from './Nav';
import ThemeContext from "../context/ThemeContext";
import "../styles/Header.css"; // Import CSS file

const Header = () => {
  const { accentColor } = useContext(ThemeContext);
  const [menuOpen, setMenuOpen] = useState(false);
  const [hovered, setHovered] = useState(false);
  const navigate = useNavigate();

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const handleClick = () => {
    navigate("/");
  };

  return (
    <div className="header-tune" style={{ backgroundColor: accentColor }}>
      <div className="header-tune-bounds">
        <div
          className="header-banner"
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
          style={{ cursor: "pointer" }}
        >
        </div>
      <Nav menuOpen={menuOpen} toggleMenu={toggleMenu} />
      </div>
    </div>
  );
};

export default Header;
